import React, { createContext, useContext, useState, useEffect } from "react";
import axios from 'axios';
import config from '../config';
import authService from "../context/AuthService";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const initValue = {
        authenticated: false,
        user_id: 0,
        email: '',
        password: '',
        name: '',
        phone: '',
        wallet_address: '',
        is_verified: false,
        access_token: '',
        currentPage: '',
        playCounts: {},
        keyword: '',
    };

    // Initialize user state with data from local storage (if available)
    // const [user, setUser] = useState(initValue);
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem("user");
        const storedPlayCounts = localStorage.getItem("playCounts");
        const storedKeyword = localStorage.getItem("keyword");

        // console.log(storedUser);
        // console.log(JSON.parse(storedUser));
        // console.log(storedPlayCounts);
        // console.log(JSON.parse(storedPlayCounts));

        let profile = (storedUser ? JSON.parse(storedUser) : initValue);
        if (storedPlayCounts) {
            profile.playCounts = JSON.parse(storedPlayCounts);
            localStorage.removeItem("playCounts");
        }

        if (storedKeyword && storedKeyword !== '') {
            profile.keyword = storedKeyword;
            localStorage.removeItem("keyword");
        }

        return profile;
    });

    const initUser = () => {
        setUser(initValue);
    };

    const loginUser = (user) => {
        // console.log(user);
        // console.log(user.access_token);
        authService.setAccessToken(user.access_token);

        setUser(user);
        localStorage.setItem("user", JSON.stringify(user));
    };

    const savePlayCounts = async () => {
        // console.log(Object.keys(user.playCounts).length);
        // localStorage.removeItem("playCounts");
        if (user.playCounts) {
            if (Object.keys(user.playCounts).length > 0) {
                localStorage.setItem("playCounts", JSON.stringify(user.playCounts));

                try {
                    // const response = await axios.post(`${config.apiBaseUrl}/play_counts`, user.playCounts);
                    const response = await authService.post(`/play_counts`, user.playCounts);
                    if (response.status === 200) {
                        localStorage.removeItem("playCounts");
                        setUser((profile) => ({
                            ...profile,
                            playCounts: {},
                        }));
                    }
                    
                } catch (error) {
                    // console.log('Failed to update play counts');
                }
            }
        }
    };

    const loadSearchKeyword = async (user_id) => {
        try {
            const response = await authService.get(`/search-keyword`, {
                params: {
                    user_id: user_id,
                }
            });
            // console.log(user_id, response);

            if (response.status === 200) {
                setUser((profile) => ({
                    ...profile,
                    keyword: response.data,
                }));
            }

        } catch (error) {
            console.log('Failed to load search keyword');
        };
    };

    const saveSearchKeyword = async () => {
        const thisKeyword = user.keyword ?? '';
        localStorage.setItem("keyword", thisKeyword);

        try {
            const response = await authService.post(`/search-keyword`, {
                user_id: user.user_id,
                keyword: thisKeyword,
            });
            if (response.status === 200) {
                localStorage.removeItem("keyword");
            }
        } catch {
            // console.log('Failed to save search keyword');
        }
    };

    const logout = async () => {
        try {
            const response = await axios.get(`${config.apiBaseUrl}/auth/logout`, {
                withCredentials: true,  // must include this to allow fastAPI to create cookies
            });
            // const response = await authService.post(`/auth/logout`);
            if (response.status === 200) {
                // console.log('Logged out successfully');
            }
            
        } catch (error) {
            // console.log('Failed to logout');
        }
    };

    const logoutUser = () => {
        try {
            savePlayCounts();
            saveSearchKeyword();
            logout();
        } catch {
            // console.log("Failed to save play counts");
        } finally {
            localStorage.removeItem("user");
            setUser(initValue);
        }
    };

    // Save user data to local storage whenever it changes
    useEffect(() => {
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        } else {
            localStorage.removeItem("user");
        }
    }, [user]);

    useEffect(() => {
        if (user.user_id > 0) {
            loadSearchKeyword(user.user_id);
        }
    }, [user.user_id]);

    useEffect(() => {
        // console.log('user', user);
        // console.log('user', user.access_token);
        // console.log('authService', authService.access_token);
        
        if (authService.access_token) {
            if (user.access_token !== authService.access_token) {
                setUser((profile) => ({
                    ...profile,
                    access_token: authService.access_token,
                }));
            }
        }
    }, [authService.access_token]);

    useEffect(() => {
        if (authService.refreshTokenExpired) {
            // console.log('Failed to refresh tokens, logout user');
            logoutUser();
            authService.refreshTokenExpired = false;
        }
    }, [authService.refreshTokenExpired]);

    // useEffect(() => {
    //     console.log('userContext mounted');
    // }, []);

    return (
        <UserContext.Provider value={{ user, setUser, initUser, loginUser, logoutUser, savePlayCounts, saveSearchKeyword, authService }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);

